import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { EdgeConfiguration } from '@cast/types-omni';

import { getEdgeConfigurationsQueryKey } from 'hooks/queries/omni/useListEdgeConfigurationsQuery';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

type Payload = {
  clusterId: string;
  edgeLocationId: string;
  edgeConfiguration: EdgeConfiguration;
};

export const useCreateEdgeConfigurationMutation = () => {
  const { currentOrganization } = useOrganizations();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      clusterId,
      edgeLocationId,
      edgeConfiguration,
    }: Payload) => {
      return apiClient.omni.createEdgeConfiguration({
        organizationId: currentOrganization!.id,
        clusterId,
        edgeLocationId,
        edgeConfiguration,
      });
    },
    onSuccess: (_data) => {
      queryClient.invalidateQueries({
        queryKey: getEdgeConfigurationsQueryKey({}),
      });
      notify.success('Edge configuration created successfully!');
    },
    onError: (error: unknown) => {
      notify.error(parseApiError(error));
    },
  });
};
